module.exports = __webpack_public_path__ + "img/add-image16.0f4a53c8.png";